import { Component, Input, OnInit } from '@angular/core';
import { SavedReportView } from '../../../../../../models/saved-report-view';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SavedReportViewService } from '../../../../../../services/saved-report-view/saved-report-view.service';


@Component({
  selector: 'app-rename-saved-report-view-modal',
  templateUrl: './rename-saved-report-view-modal.component.html',
  styleUrls: ['./rename-saved-report-view-modal.component.css']
})
export class RenameSavedReportViewModalComponent implements OnInit {
  @Input() srv: SavedReportView;
  @Input() savedCallback: (updatedSrv: SavedReportView) => undefined;

  public newName = '';

  public loadingSubmit = false;

  public genericErrorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private savedReportViewService: SavedReportViewService,
  ) {}

  ngOnInit() {
    this.newName = this.srv.name;
  }

  public handleSubmit() {
    this.genericErrorMessage = '';

    const missingRequired = (
      (this.newName === '')
    );

    if (missingRequired) {
      this.genericErrorMessage = 'Name is required.';
      return;
    }

    this.loadingSubmit = true;

    this.savedReportViewService
      .updateSavedReportViewName(
        this.srv,
        this.newName
      )
      .then(srv => {
        this.savedCallback(srv);
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.genericErrorMessage = 'Error saving view.'
        } else if (reason.status === 403) {
          this.genericErrorMessage = 'You do not have permission to rename this saved view.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }
}
